<header class="top-navbar">
    <div class="top-navbar__left">
        <div
            class="top-navbar__logo-wrapper"
            [class.is-visible]="isSidebarHidden()"
            [attr.inert]="isSidebarHidden() ? null : ''"
        >
            @if (environment.develop) {
                <div class="top-navbar__dev-ribbon">Dev</div>
            }

            <app-ui-button
                variant="icon"
                icon="menu"
                (click)="toggleSidenav()"
            ></app-ui-button>

            <a class="top-navbar__logo-link" routerLink="">
                <img
                    alt="Dashboard logo"
                    src="../../../assets/images/dashboard-logo.png"
                    class="top-navbar__logo-img"
                />
            </a>
        </div>
    </div>

    <span class="top-navbar__spacer"></span>

    <div class="top-navbar__actions">
        <app-notifications-button></app-notifications-button>

        @if (isLoggedIn()) {
            <app-ui-button
                variant="accent-outline"
                class="top-navbar__login-btn"
                icon="person"
                [text]="$safeNavigationMigration(userProfile()?.name)"
                [matMenuTriggerFor]="loginMenuAccess"
            >
            </app-ui-button>

            <mat-menu
                #loginMenuAccess="matMenu"
                xPosition="before"
                class="ui-dropdown-panel"
                hasBackdrop="true"
            >
                <button mat-menu-item routerLink="profile">
                    <mat-icon>person</mat-icon>
                    {{ 'TOP-NAVBAR.PROFILE' | translate }}
                </button>
                <button mat-menu-item (click)="logout()">
                    <mat-icon>logout</mat-icon>
                    {{ 'TOP-NAVBAR.LOGOUT' | translate }}
                </button>
            </mat-menu>
        } @else {
            <app-ui-button
                variant="accent-solid"
                class="top-navbar__login-btn"
                icon="person"
                text="TOP-NAVBAR.LOGIN-REGISTER"
                (click)="login()"
            >
            </app-ui-button>
        }
    </div>
</header>
